import { CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined } from '@ant-design/icons';
import { Result, Button } from 'antd';

export function LoadingContent() {
  return (
    <Result
      status="loading"
      icon={<LoadingOutlined twoToneColor="#ff4d4f" />}
      title="Processing, please wait..."
    />
  );
}

export function SuccessContent() {
  return (
    <Result
      status="success"
      icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
      title="Registeration Success"
      subTitle="Thank you for subscribing to DigiFusion Platform via AWS Marketplace. Our onboarding team will be in touch with you shortly."
      extra={
        <Button type="default" onClick={() => (window.location.href = process.env.REACT_APP_RETURN_WEB_URL)}>
          Official Website Home
        </Button>
      }
    />
  );
}

export function ErrorContent() {
  return (
    <Result
      status="verification_failed"
      icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}
      title="Data not found"
      subTitle="Please return to AWS to resubscribe."
      extra={
        <Button type="default" onClick={() => (window.location.href = process.env.REACT_APP_MARKETPLACE_URL)}>
          AWS Marketplace
        </Button>
      }
    />
  );
}